module.exports = __webpack_public_path__ + "img/card-loyal3.9d25edcd.svg";